import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Button, DialogActions, TextField} from "@mui/material";
import {FormElement} from "../molcules/forms";
import Dialog from "@mui/material/Dialog";
import React, {useState} from "react";

export const CreateKiteDialog = ({open, triggerCreateKite, handleClose, kiteTemplates }) => {
  const [state, setState] = useState({name: '', targetCustomer: 'All', template:'General'});

  return (
    <Dialog open={open} onClose={handleClose}  aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Create New Kite</DialogTitle>
      <DialogContent>
        <div style={{width:'400px', margin:'16px 0'}}>
          <div style={{marginBottom:32}}>
            <TextField
              id={'name'}
              label={'Name'}
              onChange={(e) => {
                setState(prev => ({...prev, name: e.target.value}));
              }}
              value={state.name}
              variant="outlined"
              className="control"
            />
          </div>
          <div style={{marginBottom:32}}>
            <FormElement
              style={{textTransform: 'capitalize'}}
              label={'Select Customer Type'}
              handleChange={(e)=>{
                setState(prev => ({...prev, targetCustomer: e.target.value}));
              }}
              type={'select'}
              id={'targetSelect'}
              selectValues={[ {title: 'All'}, {title: 'Sleeper'}, {title: 'Non Sleeper'} ]}
              values={{targetSelect: state.targetCustomer}}
            />
          </div>
          <FormElement
            style={{textTransform: 'capitalize'}}
            label={'Select Kite Template'}
            handleChange={(e)=>{
              setState(prev => ({...prev, template: e.target.value}));
            }}
            type={'select'}
            id={'typeSelect'}
            selectValues={kiteTemplates.map((kite)=>({title: kite.name}))}
            values={{typeSelect: state.template}}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={() => {
          triggerCreateKite(state);
          handleClose();
        }}>Add</Button>
      </DialogActions>
    </Dialog>
  );
}
